var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import View from 'ol/View';
/**
 * @typedef {import("ol/View").default} View
 * @typedef {import("ol/Object").default} BaseObject
 */
/**
 * @class  DMView
 * @this {BaseObject}
 */
var DMView = /** @class */ (function (_super) {
    __extends(DMView, _super);
    function DMView(props) {
        var _this = _super.call(this, props) || this;
        _this.level = 0;
        _this.language = props && props.language ? props.language : null;
        _this.backgroundZoom = 0;
        return _this;
    }
    DMView.prototype.notify = function (key, value) {
        _super.prototype.notify.call(this, key, value);
    };
    DMView.prototype.getLevel = function () {
        return this.level;
    };
    DMView.prototype.setLevel = function (value) {
        var oldValue = this.level;
        this.level = value;
        this.notify('level', oldValue);
    };
    DMView.prototype.getLanguage = function () {
        return this.language;
    };
    DMView.prototype.setLanguage = function (value) {
        var oldValue = this.language;
        this.language = value;
        this.notify('language', oldValue);
    };
    DMView.prototype.getBackgroundZoom = function () {
        return this.backgroundZoom;
    };
    DMView.prototype.setBackgroundZoom = function (value) {
        var oldValue = this.backgroundZoom;
        this.backgroundZoom = value;
        this.notify('backgroundZoom', oldValue);
    };
    return DMView;
}(View));
export { DMView };
export default DMView;
//# sourceMappingURL=view.js.map